import React, {useState,useEffect,useContext} from "react";
import { useLocation,useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';
import helpers from "../_helpers/helpersFunction";
import Context from '../context/context';
import ReactGA from 'react-ga4';
import { useGoogleLogin } from '@react-oauth/google';
const config = require("../_helpers/configServizi");

// Login Facebook e Apple: codice pronto ma non ancora attivo (manca la configurazione su Facebook/Apple) -> true per mostrarli
const LOGIN_FACEBOOK_APPLE_ATTIVO = false;
// Login Google nella pagina di login: nascosto come in master (lì il blocco è commentato) -> true per mostrarlo
const LOGIN_GOOGLE_ATTIVO = false;

export default function Signup(props) {
    const  context = useContext(Context)

	const [errore, setErrore] = useState("");
	const [spinner, setSpinner] = useState(false);
	const [bottoneForm, setBottoneForm] = useState(Lang( {"w": "accedi","page": "signupForm","var":true} ));

	const [animazione, setAnimazione] = useState("");
	const [isFbReady, setIsFbReady] = useState(!!window.fbReady);
	
	const [activeError, setActiveError] = useState(false);

	const [form_email, setForm_email] = useState('');
  	const [form_password, setForm_password] = useState('');
	  const [formError, setFormError] = useState({email:false,password:false});
	 
	var location = useLocation();
	location = location.pathname.split("/")

	const navigate = useNavigate();
	
    const onSubmit = (e) => {


		e.preventDefault();
		var data = {}
		

		try{

			if(checkErrori()){
				setSpinner(false);
				return
			}
		
			setSpinner(true);
			setErrore("");
			const domain = window.location.hostname;
		
			data.email =  form_email.replace(/\s+/g, '');
			data.password = form_password;
			data.country = localStorage.getItem('country');
			data.city = localStorage.getItem('city');
			data.region = localStorage.getItem('region');
			data.ip = localStorage.getItem('ip');
			data.clickid=localStorage.getItem('trackerId');
			data.fingerprint = localStorage.getItem('fingerprint');
			data.fluxId = context.fluxId ? context.fluxId:  config.servizi[domain].default_fluxid
			data.servizio =  window.location.hostname;
					
			
			Auth.login(data)
			.then(user => {

				if(!user.message && !user.account_active){
					setSpinner(false);
					setErrore(Lang( {"w": "utente_disabilitato","page": "popupHook"} ));
					return
				}
				
				if(user.token){
					localStorage.setItem('token',user.token);
					helpers.setUser(user,context,true,true)
					helpers.GetNavigation(user.clickid,context)
					navigate("/")
					if(user.flusso.optin == "doi" && user.confirmed_email === false){
						helpers.showPopuphook("doi",context,user)
						
						return
					}

				}else{
					setSpinner(false);
					setErrore(Lang( {"w": "mail_password_errati","page": "signupForm"} ));
				}
				
			})

		}catch(err){
			console.log(err)
		}
		
		
	};


	const googleLogin = useGoogleLogin({
		flow: 'auth-code',
		onSuccess: async (codeResponse) => {
			
			const domain = window.location.hostname;
	
			var data = {}
			
			data.source = localStorage.getItem('source') ? localStorage.getItem('source') : null
			data.country = localStorage.getItem('country') ? localStorage.getItem('country') : helpers.getCountry()
			data.campid = localStorage.getItem('campid') ? localStorage.getItem('campid') : ""
			data.ip = localStorage.getItem('ip') ? localStorage.getItem('ip') : null;
			data.clickid=localStorage.getItem('trackerId') ? localStorage.getItem('trackerId') : Math.random().toString(36).slice(2);
			data.fingerprint = localStorage.getItem('fingerprint') ? localStorage.getItem('fingerprint') : null
			data.fluxId = context.fluxId ? context.fluxId:  config.servizi[domain].default_fluxid
			data.servizio =  window.location.hostname;
			data.ua =  localStorage.getItem('ua') ? localStorage.getItem('ua') : null;
			data.code = codeResponse.code
			
				const res = await Auth.HOME_authWithGoogle(data)
			
			if(res.token){
			
				helpers.setUser(res,context,false,false)
				helpers.setAnalyticsDimensions(data.clickid,data.source,data.country,data.fluxId,true)
				helpers.GetNavigation(res.clickid,context)
				navigate("/")
				
				// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
				if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
					helpers.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
					return;
				}

				if(!res.login){
					context.setPopupHook({ ...context.popupHook, provenienza:"impostaRegione"});
					context.setModalShowHook(true);
					return;
				}else{

					context.setVerifiedUser(true)
					context.processoDiNotifica()
			  	}

			}else{
				setErrore(helpers.errorCodes(res));
				setSpinner(false); 
			}
		},
		onError: errorResponse => console.log(errorResponse),
	});


	const loginWithFacebook = () => {
		if (!window.fbReady) {
			setErrore("Facebook non disponibile. Prova a disabilitare il blocco tracker del browser.")
			return
		}
		window.FB.login((response) => {
			console.log("[FB] risposta dialogo:", response)
			if (response.authResponse) {
				handleFacebookAuth(response.authResponse.accessToken)
			} else {
				console.log("[FB] authResponse assente – status:", response.status)
			}
		}, { scope: 'email,public_profile' })
	}

	// Login via Facebook da home/login page → usa endpoint Home
	const handleFacebookAuth = async (accessToken) => {
		console.log("[FB] handleFacebookAuth chiamata, accessToken:", accessToken)
		const domain = window.location.hostname
		var data = {}
		data.source      = localStorage.getItem('source') || null
		data.country     = localStorage.getItem('country') || helpers.getCountry()
		data.campid      = localStorage.getItem('campid') || ""
		data.ip          = localStorage.getItem('ip') || null
		data.clickid     = localStorage.getItem('trackerId') || Math.random().toString(36).slice(2)
		data.fingerprint = localStorage.getItem('fingerprint') || null
		data.fluxId      = context.fluxId || config.servizi[domain].default_fluxid
		data.servizio    = window.location.hostname
		data.ua          = localStorage.getItem('ua') || null
		data.access_token = accessToken

		console.log("[FB] payload inviato al backend:", data)
		const res = await Auth.Home_authWithFacebook(data)
		console.log("[FB] risposta backend:", res)

		if (res.needsRegistration) { navigate("/signup", { state: { fbPrefill: res.prefill } }); return }
		if (res.token) {
			helpers.setUser(res, context, false, false)
			helpers.setAnalyticsDimensions(data.clickid, data.source, data.country, data.fluxId, true)
			helpers.GetNavigation(res.clickid, context)
			navigate("/")

			// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
			if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
				helpers.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
				return;
			}

			if (!res.login) {
				context.setPopupHook({ ...context.popupHook, provenienza: "impostaRegione" })
				context.setModalShowHook(true);
				return;
			} else {
				context.setVerifiedUser(true)
				context.processoDiNotifica()
			}
		} else {
			setErrore(helpers.errorCodes(res))
			setSpinner(false)
		}
	}

	// ================================= APPLE Handlers ====================================

	const loginWithApple = async () => {
		if(!window.AppleID) {
			console.log("[Apple] window.AppleID assente: SDK non caricato o init non eseguito (vedi index.html)");
			setErrore("Apple login non disponibile. Riprova tra un istante.");
			return;
		}
		try {
			// Inseriamo qui il solo il sign-in (abbiamo init )
			console.log("[Apple] avvio signIn()...");
			const response = await window.AppleID.auth.signIn();
			console.log("[Apple] risposta signIn:", { hasIdToken: !!response?.authorization?.id_token, hasUser: !!response?.user });
			const id_token = response?.authorization?.id_token;
			if(!id_token) { console.log("[Apple] id_token assente nella risposta di signIn"); return; }
			await handleAppleAuth(id_token, response.user || null);
		} catch (e) {
			console.log("[Apple] login annullato/errore:", e?.error || e?.message || e);
		}
	};


	const handleAppleAuth = async (id_token, appleUser) => {
		const domain = window.location.hostname;
		var data = {};
		data.source      = localStorage.getItem('source') || null;
		data.country     = localStorage.getItem('country') || helpers.getCountry();
		data.campid      = localStorage.getItem('campid') || "";
		data.ip          = localStorage.getItem('ip') || null;
		data.clickid     = localStorage.getItem('trackerId') || Math.random().toString(36).slice(2);
		data.fingerprint = localStorage.getItem('fingerprint') || null;
		data.fluxId      = context.fluxId || config.servizi[domain].default_fluxid;
		data.servizio    = window.location.hostname;
		data.ua          = localStorage.getItem('ua') || null;
		data.id_token    = id_token;
		data.user        = appleUser; // oggetto Apple (solo 1° login) o null

		console.log("[Apple] payload inviato al backend:", { ...data, id_token: "(presente, len " + (id_token?.length || 0) + ")" });
		const res = await Auth.Home_authWithApple(data);
		console.log("[Apple] risposta backend:", res?.token ? { token: "(presente)", login: res.login, clickid: res.clickid } : res);
		if(res.token) {
			helpers.setUser(res, context, false, false);
			helpers.setAnalyticsDimensions(data.clickid, data.source, data.country, data.fluxId, true);
			helpers.GetNavigation(res.clickid, context);
			navigate("/");

			// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
			if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
				helpers.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
				return;
			}
			
			if(!res.login) {
				context.setPopupHook({ ...context.popupHook, provenienza: "impostaRegione" });
				context.setModalShowHook(true);
				return;
			} else {
				context.setVerifiedUser(true);
				context.processoDiNotifica();
			}
		} else {
			setErrore(helpers.errorCodes(res));
			setSpinner(false);
		}
	};

    useEffect(() => {
		if (!window.fbReady) {
			const onReady = () => setIsFbReady(true);
			window.addEventListener('fb-sdk-ready', onReady);
			return () => window.removeEventListener('fb-sdk-ready', onReady);
		}
	}, []);

    useEffect(() => {

        //form registrazione


	},[]);


    function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		  <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
		</div>);
		}else{
			return false;
		}
	}



	function checkErrori(){
		if(form_email.length == 0){
			setFormError({...formError,email:true})
			setErrore(Lang( {"w": "errore_email","page": "signupForm"} ));
			return true
		} 
		
		if(form_password.length == 0){
			setFormError({...formError,password:true})
			setErrore(Lang( {"w": "errore_password","page": "signupForm"} ));
			return true
		}
		
	}

	function handleInputChange(target) {
		const value = target.currentTarget.value;
		
		if (target.currentTarget.name === "email") {
			setForm_email(target.currentTarget.value)
		}

		if (target.currentTarget.name === "password") {
			setForm_password(target.currentTarget.value)
		}

		
	}


      return (<div>
        <h1><Lang w={"gia_account"} page={"popupHook"}/></h1>
        <p><Lang w={"accedi_subito"} page={"popupHook"}/></p>
    <form className={"formSignup " + animazione} onSubmit={onSubmit}>
        <input type="email" name="email"  placeholder="Email" required  onChange={(e) => handleInputChange(e)}></input>
        <input type="password" name="password"   placeholder="Password" required onChange={(e) => handleInputChange(e)}></input>
        {errore && (<p className='erroreSignup'>{errore}</p>)}
        <Spinner/>
        <input type="submit" value={bottoneForm} disabled={spinner}></input>
        <a onClick={() =>navigate("/signup")}><Lang w={"iscriviti"} page={"signupForm"}/></a> 
		<br/>      
		<a onClick={() =>navigate("/forgotPassword")}><Lang w={"password_dimenticata"} page={"signupForm"}/></a>	
		{(LOGIN_GOOGLE_ATTIVO || LOGIN_FACEBOOK_APPLE_ATTIVO) && <div className="signupGoogleContainer">
                <h5 className="orsignwithgoogle">O</h5>

                {LOGIN_GOOGLE_ATTIVO && <button type="button" className="signwithsocial signwithsocial--google" onClick={() => googleLogin()}><i class="fab fa-brands fa-google"></i>Sign in with Google</button>}
                {LOGIN_FACEBOOK_APPLE_ATTIVO && <>
                <button type="button" className="signwithsocial signwithsocial--facebook" onClick={loginWithFacebook}><i className="fab fa-facebook-f"></i>Sign in with Facebook</button>
				<button type="button" className="signwithsocial signwithsocial--apple" onClick={loginWithApple}>
					<i className="fab fa-apple"></i> Sign in with Apple
				</button>
                </>}
              </div>}
    </form></div>);
	
	
}